import MoaPanel from "./moa_panel";
import { getSvgIconElement } from "../../../helpers/svg";
// SVG assets imported as markup strings (esbuild `.svg: "text"` loader), attached as
// real nodes so `currentColor` themes them — never CSS data-URIs, whose fills are frozen.
// The spinner self-animates (its own <style> keyframes); the tick is the shared artwork.
import iconTickSvg from "../assets/icon__tick.svg";
import iconSpinnerSvg from "../assets/icon__spinner.svg";

// AcceptSubmitButton — the accept panel's "Go" button, a small subcomponent so the
// endpoint state paints ON the button block itself (--loading spinner / --success
// tick, plus the disabled lock-in) instead of reaching down from a host-level
// modifier through the panel. Constructed and adopted by AcceptForm; the auth
// panels' Go buttons share the markup block but have no states, so they stay plain.
export const AcceptSubmitButtonConfig = {
  componentTypeKey: "MoaAcceptSubmitButton",
  baseHtmlClass: "member_offer_acceptor__form__btn",
  selector: ".member_offer_acceptor__form__btn",

  // The type is the point — the form's one submit control (cf. auth_username).
  submitInputSelector: "input[type=submit]",

  // Overlay holders this component attaches over the control (see buildOverlayIcon).
  tickHtmlClass: "member_offer_acceptor__form__btn__tick",
  spinnerHtmlClass: "member_offer_acceptor__form__btn__spinner",

  // The two endpoint statuses the button visualises; any other status (idle | error |
  // failure) clears both, restoring the plain "Go". Values mirror EndpointStatuses
  // .loading/.success — importing them here would cycle back through the host module.
  visualStates: ["loading", "success"],
};

export class AcceptSubmitButton extends MoaPanel {
  static get config() { return AcceptSubmitButtonConfig; }

  constructor(id_or_element, host) {
    super(id_or_element, host, AcceptSubmitButtonConfig);
    this.submitInput = this.element.querySelector(AcceptSubmitButtonConfig.submitInputSelector);

    // Attached ONCE here; the CSS state modifiers just fade them in/out
    // (_accept_submit_button.scss), so render() never touches the DOM tree.
    this.tickElement = this.buildOverlayIcon(AcceptSubmitButtonConfig.tickHtmlClass, iconTickSvg);
    this.spinnerElement = this.buildOverlayIcon(AcceptSubmitButtonConfig.spinnerHtmlClass, iconSpinnerSvg);
  }

  buildOverlayIcon(htmlClass, svgString) {
    const holder = document.createElement("span");
    holder.classList.add(htmlClass);
    holder.setAttribute("aria-hidden", "true");
    holder.appendChild(getSvgIconElement(svgString));
    this.element.appendChild(holder);
    return holder;
  }

  render() {
    this.selectHtmlClassState(this.host.getEndpointStatus(), AcceptSubmitButtonConfig.visualStates);

    // Disabled on success only — the locked-in claim. A signed-in person must still
    // be able to tap Go (their email/name fields are disabled, this button is not).
    this.submitInput.disabled = this.host.submissionWasSuccessful();
  }
}
